import { render } from "./CoLtdIntroEmbed.vue?vue&type=template&id=6ac3edf1&scoped=true"
import script from "./CoLtdIntroEmbed.vue?vue&type=script&lang=js"
export * from "./CoLtdIntroEmbed.vue?vue&type=script&lang=js"

import "./CoLtdIntroEmbed.vue?vue&type=style&index=0&id=6ac3edf1&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac3edf1"]])

export default __exports__